import { TFunction } from 'i18next'

const steps = (t: TFunction) => [
    {
        selector: '#url',
        content: t('cv-url-steps'),
    },
    {
        selector: '#name',
        content: t('cv-name-steps'),
    },
    {
        selector: '#email',
        content: t('cv-email-steps'),
    },
    {
        selector: '#day-of-birthday',
        content: t('cv-day-of-birthday-steps'),
    },
    {
        selector: '#phone',
        content: t('cv-phone-steps'),
    },
    {
        selector: '#address',
        content: t('cv-address-steps'),
    },
    {
        selector: '#job-title',
        content: t('cv-job-title-steps'),
    },
    {
        selector: '#cover-letter-source-id',
        content: t('cv-source-steps'),
    },
    {
        selector: '#types-of-position',
        content: t('cv-types-of-position-steps'),
    },
    {
        selector: '#department',
        content: t('cv-department-steps'),
    },
    {
        selector: '#about',
        content: t('cv-about-steps'),
    },
    {
        selector: '#create-cv',
        content: t('create-cv'),
    },
]

export default steps
